import {
    useIsAuthenticated,
    useMsal
  } from "@azure/msal-react";
import { useEffect } from 'react';
import { loginRequest } from '../config/msalConfig';

export default function Login() {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

    useEffect(() => {
        
      console.log('Login component mounted');

        const handleLogin = () => {
          console.log('Handle login called, isAuthenticated:', isAuthenticated);
            if (!isAuthenticated) {
              console.log('User is not authenticated, initiating login...');
              instance.loginRedirect(loginRequest).catch(e => {
                  //console.log(e);
              });
            }
        };

        console.log('Login component mounted, isAuthenticated:', isAuthenticated);

        handleLogin();
    }, []);

    
  return (
    <div>
      <p>Loading...</p>
    </div>
  );
}